import { render, staticRenderFns } from "./GameAttributes.vue?vue&type=template&id=0d9449d4&scoped=true"
import script from "./GameAttributes.vue?vue&type=script&lang=js"
export * from "./GameAttributes.vue?vue&type=script&lang=js"
import style0 from "./GameAttributes.vue?vue&type=style&index=0&id=0d9449d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d9449d4",
  null
  
)

export default component.exports